import { EXTENSOES_DOWNLOAD, EXTENSOES_IMAGEM, EXTENSOES_VIDEO } from '../../../utils/chat.constantes';

export const EXTENSOES_PERMITIDAS = [...EXTENSOES_IMAGEM, ...EXTENSOES_DOWNLOAD, 'pdf', ...EXTENSOES_VIDEO, 'mp3'];

export const CHAVE_RASCUNHO = 'chat-rascunho:';

export const FORMATOS_GRAVACAO = [
  { mime: 'audio/webm;codecs=opus', extensao: 'webm' },
  { mime: 'audio/webm', extensao: 'webm' },
  { mime: 'audio/mp4', extensao: 'm4a' },
  { mime: 'audio/ogg;codecs=opus', extensao: 'ogg' },
];

export const DURACAO_MINIMA_GRAVACAO_MS = 1000;
export const QTD_BARRAS_GRAVACAO = 48;
export const INTERVALO_AMOSTRA_GRAVACAO_MS = 90;
